<template>
  <div class="bg-charcoal py-15">
    <div class="w-1/2 mx-auto cursor-pointer" @click="openDialog = true">
      <UiAsset
        class="aspect-h-5 aspect-w-4"
        :asset="asset"
        :product-data="productData"
      />
    </div>
  </div>
  <DialogsImagePreviewDialog
    v-model="openDialog"
    :src="asset"
    :alt="asset?.alt || ''"
    :type="asset?.type || ''"
  />
</template>
<script setup lang="ts">
import { ProductData } from "ecom-types";

// TODO: Need to replace to MF
interface ImageData {
  alt?: string;
  url: string;
  type?: string;
  listType?: string;
}

defineProps<{
  asset: ImageData;
  productData: ProductData;
}>();

const openDialog = ref<boolean>(false);
</script>

<style scoped></style>
